import React, { useEffect } from "react";
import logoImg from './images/logobithappier.png';
import homeLogoFund from './images/mainLogo.webp';
import HomepageHeader from './HomepageHeader';
import './Homepage.css';
import aboutImg from './images/aboutimg.svg';
import ourVision from './images/vision.svg';
import ourMission from './images/mission.svg';
import ourVisionMission from './images/visionmission.svg';
import Team from './Landingpage/Components/Team';
import Roadmap from './Landingpage/Components/Roadmap';
import FooterHome from './FooterHome';
import FooterHomeStripe from './FooterHomeStripe';
import Cookies from 'universal-cookie';
import DashboardHeader from './DashboardHeader';
import ProfessionalHeader from '../Professionals/ProfessionalHeader';
import { DecodingString } from '../helperFunction/DecodingString';
import { useNavigate } from 'react-router-dom';
import back from './images/ArrowRight.png'
import final from './images/finalHome.png'
import { useLocation } from 'react-router-dom';
import './Fundraiser.css'
import Pic from './images/Pic.png'


const Fundraiser = () => {
  const cookies = new Cookies();
  const token = cookies.get('isLoggedIn', { path: '/' });
  const roleType = DecodingString(cookies.get('_ssUuId', { path: '/' }));
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);




  return (
    <>
      <header>
        {token ? (
          <>
            {roleType === 'ROLE_USER' || roleType === 'ROLE_CORPORATE' ? (
              <DashboardHeader />
            ) : (
              <ProfessionalHeader />
            )}
          </>
        ) : (
          <div className='hv2-root'>
            <HomepageHeader />
          </div>
        )}
      </header>

      {/* ── HERO SECTION ── */}
      <div className="fundraiser-hero hero-shadow-fix">
        <div className="fundraiser-top-bar">
          <div className="fundraiser-logo">
            <span
              onClick={() => navigate(-1)}
              className="fundraiser-back-link"
            >
              <img className="me-2" src={back} alt="" width={20} />
              Back
            </span>
          </div>
          <a
            href="https://stigmafreementalhealth.com/donate/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-tickets fundraiser-donate-btn"
            aria-label="Donate today"
          >
            Donate Today
          </a>
        </div>
        <div className="fundraiser-bottom-container">
          <p className="fundraiser-bottom-text">2026 FUNDRAISER</p>
        </div>
      </div>

      {/* ── CARD SECTION ── */}
      <div className="main-wrapper">
        <div className="card-wrapper">
          <div className="card">
            <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/sparkles.png" alt="" className="sparkles" />
            <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/champion-flame-200x300.png" alt="" className="flame" />
            <div className="top-content">
              <p className="label">Fundraiser</p>
              <h1 className="title">
                Illuminate:<br />
                Champions for Change
              </h1>
            </div>
            <div className="ribbon">
              <span className="ribbon-text">
                April 30, 2026 • Doors Open 6PM • Arts Umbrella, Granville Island (Metro Vancouver)
              </span>
            </div>
            <div className="bottom-content">
              <div className="brought-by">
                <span className="brought-by-label">Brought to you by:</span>
                <div className="logos">
                  <a className="logo-circle" href="https://stigmafreementalhealth.com/" target="_blank">
                    <img src="https://stigmafreementalhealth.com/wp-content/uploads/2023/05/SFMH-logo-1080X1080-White.png.webp" alt="Stigma-Free Mental Health" />
                  </a>
                  <button className="logo-circle purple" onClick={() => {
                    navigate(-1);
                  }}>
                    <img src={Pic} alt="Bit Happier" />
                  </button>
                </div>
              </div>
              <div className="buttons">
                <button onClick={() => navigate('/tickets')} className="btn-2 btn-gold">Sponsorship & Tickets</button>
                <button onClick={() => {
                  window.open('mailto:info@stigmafreementalhealth.com');
                }} className="btn-2 btn-outline">
                  Event Inquiries
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── ABOUT THE EVENT SECTION ── */}
      <section className="about-section">
        <div className="about-bg-overlay" />
        {/* Gold floral corner decoration */}
        <img
          src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/dec-corner-rt-296x300.png"
          alt=""
          className="about-floral-corner"
        />
        <div className="about-inner">
          <h2 className="about-title">About The Event</h2>
          <p className="about-text">
            <strong>Illuminate: Champions for Change</strong> is a special fundraising event that highlights inspiring leaders and organizations working to improve mental health and strengthen communities. The evening brings together supporters, advocates, and changemakers to celebrate stories of transformation and impact while raising critical funds to address loneliness and mental health challenges.
          </p>
          <p className="about-text">
            The <strong>Champions for Change</strong> concept recognizes individuals and organizations who are making a meaningful difference in people's lives. Each Champion represents a cause, initiative, or organization that is actively creating positive social change. Through storytelling and community engagement, the event shines a light on these efforts and the real impact they have on individuals and communities.
          </p>
          <p className="about-text">
            This collaborative fundraiser supports initiatives focused on reducing stigma, improving mental wellness, and addressing the growing issue of loneliness. By bringing together community leaders, organizations, and supporters, Illuminate: Champions for Change aims to foster connection, raise awareness, and generate meaningful support for programs that help people live healthier, more connected lives.
          </p>
          {/* Stats bubbles */}
          <div className="stats-row">
            <div className="stat-bubble">
              <div className="stat-number">1 in 4<br />Canadians</div>
              <div className="stat-desc">experience mental illness each year</div>
            </div>
            <div className="stat-bubble">
              <div className="stat-number">4,500 Suicide<br />Deaths</div>
              <div className="stat-desc">occurred in Canada last year</div>
            </div>
            <div className="stat-bubble">
              <div className="stat-number">1 in 10<br />Canadians</div>
              <div className="stat-desc">feel lonely often or always</div>
            </div>
            <div className="stat-bubble">
              <div className="stat-number">1 in 5<br />Canadians</div>
              <div className="stat-desc">diagnosed with mental illness by age 25</div>
            </div>
          </div>
        </div>
        {/* Gold ribbon at bottom */}
        <div className="about-ribbon">
          <span className="about-ribbon-text">
            Supporting Programs That Reduce Stigma and Strengthen Mental Wellbeing
          </span>
        </div>
      </section>

      {/* ── CHAMPIONS FOR CHANGE SECTION ── */}
      <section className="champions-section">
        <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/sparkles.png" alt="" className="champions-sparkles" />
        <div className="champions-inner">
          <h2 className="champions-title">Champions for Change</h2>
          <div className="champions-grid">
            {/* Champion 1 */}
            <a
              href="https://www.artsumbrella.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="champion-card-link"
              aria-label="Learn more about Paul Larocque at Arts Umbrella"
            >
              <div className="champion-card">
                <div className="champion-circle">
                  <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/Paul_Larocque-Cropped.jpg" alt="Paul Larocque" />
                </div>
                <h3 className="champion-name">Paul Larocque</h3>
                <p className="champion-role">CEO</p>
                <span className="champion-org">Arts Umbrella</span>
              </div>
            </a>
            {/* Champion 2 */}
            <a
              href="https://www.risehelps.ca/"
              target="_blank"
              rel="noopener noreferrer"
              className="champion-card-link"
              aria-label="Learn more about Tassan Sung at Rise Helps"
            >
              <div className="champion-card">
                <div className="champion-circle">
                  <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/Screenshot-2026-03-12-120010.png" alt="Tassan Sung" />
                </div>
                <h3 className="champion-name">Tassan Sung</h3>
                <p className="champion-role">Board Director</p>
                <span className="champion-org">Rise Helps</span>
              </div>
            </a>
            {/* Champion 3 */}
            <a
              href="https://bcparksfoundation.ca/"
              target="_blank"
              rel="noopener noreferrer"
              className="champion-card-link"
              aria-label="Learn more about Dr. Andrew Day at BC Parks Foundation"
            >
              <div className="champion-card">
                <div className="champion-circle">
                  <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/Screenshot-2026-03-12-120217.png" alt="Dr. Andrew Day" />
                </div>
                <h3 className="champion-name">Dr. Andrew Day</h3>
                <p className="champion-role">CEO</p>
                <span className="champion-org">BC Parks Foundation</span>
              </div>
            </a>
            {/* Champion 4 */}
            <a
              href="https://kidsplayfoundation.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="champion-card-link"
              aria-label="Learn more about Kal Dosanjh at Kids Play"
            >
              <div className="champion-card">
                <div className="champion-circle">
                  <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/Screenshot-2026-03-12-120423.png" alt="Kal Dosanjh" />
                </div>
                <h3 className="champion-name">Kal Dosanjh</h3>
                <p className="champion-role">Founder</p>
                <span className="champion-org">Kids Play</span>
              </div>
            </a>
            {/* Champion 5 */}
            <a
              href="https://forsocialchange.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="champion-card-link"
              aria-label="Learn more about Frans Tjallingii at Foundations for Social Change"
            >
              <div className="champion-card">
                <div className="champion-circle">
                  <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/Screenshot-2026-03-12-120601.png" alt="Frans Tjallingii" />
                </div>
                <h3 className="champion-name">Frans Tjallingii</h3>
                <p className="champion-role">Co-Founder & Director</p>
                <span className="champion-org">Foundations for Social Change</span>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* ── SPONSORSHIP & TICKETS SECTION ── */}
      <section className="tickets-section">
        <div className="tickets-overlay" />
        <div className="tickets-inner">
          <button
            // href="https://stigmafreementalhealth.com/sponsorship-tickets/"
            // target="_blank"
            // rel="noopener noreferrer"
            className="btn-tickets-sponsor"
            aria-label="Sponsorship and Tickets"
            onClick={() => navigate('/tickets')}
          >
            Sponsorship &amp; Tickets
          </button>
        </div>
      </section>

      {/* ── THANK YOU FROM OUR TEAM SECTION ── */}
      <section className="team-section">
        <img
          src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/dec-corner-legft-150x150.png"
          alt=""
          className="team-floral-corner"
        />
        <div className="team-inner">
          <h2 className="team-title">Thank You From Our Team</h2>
          <div className="team-grid">
            <div className="team-card-2">
              <div className="team-circle">
                <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/Andrea.png.webp" alt="Andrea Paquette" />
              </div>
              <h3 className="team-name">Andrea Paquette</h3>
              <p className="team-role">President & Co-Founder</p>
              <p className="team-org">Stigma-Free Mental Health</p>
            </div>
            <div className="team-card-2">
              <div className="team-circle">
                <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/Akshay.png.webp" alt="Akshay Gupta" />
              </div>
              <h3 className="team-name">Akshay Gupta</h3>
              <p className="team-role">CEO</p>
              <p className="team-org">Bit Happier</p>
            </div>
            <div className="team-card-2">
              <div className="team-circle">
                <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/Raj.png.webp" alt="Raj Singh" />
              </div>
              <h3 className="team-name">Raj Singh</h3>
              <p className="team-role">Board Director</p>
              <p className="team-org">Stigma-Free Mental Health & Bit Happier</p>
            </div>
            <div className="team-card-2">
              <div className="team-circle">
                <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/Nigel.png.webp" alt="Nigel Andison" />
              </div>
              <h3 className="team-name">Nigel Andison</h3>
              <p className="team-role">Director</p>
              <p className="team-org">Pathfinder Asset Management</p>
            </div>
            <div className="team-card-2">
              <div className="team-circle">
                <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/Dave.png.webp" alt="Dave Richardson" />
              </div>
              <h3 className="team-name">Dave Richardson</h3>
              <p className="team-role">Co-Founder & Board Chair</p>
              <p className="team-org">Stigma-Free Mental Health</p>
            </div>
            <div className="team-card-2">
              <div className="team-circle">
                <img src="https://stigmafreementalhealth.com/wp-content/uploads/2026/03/Praveen.png.webp" alt="Praveen Varshney" />
              </div>
              <h3 className="team-name">Praveen Varshney</h3>
              <p className="team-role">FCPA, FCA / Partner</p>
              <p className="team-org">Varshney Capital Corp.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── THANK YOU FOR YOUR SUPPORT SECTION ── */}
      <section className="support-section">
        <div className="support-inner">
          <h2 className="support-title">Thank You For Your Support.</h2>
          <p className="support-text">
            Together, we inspire diverse communities to be inclusive, compassionate,<br />
            and empowered to lead fulfilling lives regardless of their challenges.
          </p>
        </div>
      </section>

      <footer >
        <FooterHome />
      </footer >
    </>
  );
};
export default Fundraiser;